const Sites = {
  consumer: 'consumer',
  dealer: 'dealer'
}

export default Sites
